const ONETRUST_SDK_URL = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
const ONETRUST_DOMAIN_PROD = '5189fc21-0510-46b7-a512-3f991cf8670a';
const ONETRUST_DOMAIN_TEST = '5189fc21-0510-46b7-a512-3f991cf8670a-test';

function isProductionHostname(): boolean {
  return window.location.hostname === 'eventregistrations.deloitte.com';
}

export function initCookieConsent(): void {
  if (document.querySelector('script[data-domain-script]')) return;

  const globalWindow = window as Window & { OptanonWrapper?: () => void };

  if (typeof globalWindow.OptanonWrapper !== 'function') {
    globalWindow.OptanonWrapper = () => {};
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = ONETRUST_SDK_URL;
  script.setAttribute(
    'data-domain-script',
    isProductionHostname() ? ONETRUST_DOMAIN_PROD : ONETRUST_DOMAIN_TEST,
  );
  document.head.appendChild(script);
}